import {Component, Input} from '@angular/core';

@Component({
	selector: 'payroll-placeholder',
	styles: [
		'.ph-avatar {width: 30px;margin-left: 32px;min-width:unset!important;}',
		'.ph-item {background-color: transparent!important; margin-top: 15px!important; margin-bottom: 7px!important;}',
		'.ph-row div {margin-bottom:2px; min-height: 10px;}',
		'.ph-row {padding: 0;margin-bottom: 0;margin-top: 0;}',
	],
	template: `
		<div class="ph-item" *ngIf="loadingSalary">
			<div class="ph-row">
				<div class="ph-col-12"></div>
			</div>
		</div>
		<ng-container *ngIf="!loadingSalary">
			<div class="ph-item" *ngFor="let i of rows | ngForTimes">
				<div class="ph-col-2">
					<div class="ph-avatar"></div>
				</div>
				<div>
					<div class="ph-row">
						<div class="ph-col-4"></div>
						<div class="ph-col-4 empty"></div>
						<div class="ph-col-4"></div>
						<div class="ph-col-12 empty"></div>
						<div class="ph-col-4"></div>
						<div class="ph-col-4 empty"></div>
						<div class="ph-col-4"></div>
					</div>
				</div>
			</div>
		</ng-container>
	`,
})
export class PayrollPlaceholderComponent {
	@Input() public rows: number = 3;
	@Input() public loadingSalary: boolean = false;
}
